import { Injectable } from '@angular/core';
import { HttpClient, HttpErrorResponse } from '@angular/common/http';

import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

import { environment } from '../../environments/environment';
import { HP } from '../models/hp.model';

@Injectable({
    providedIn: 'root'
})
export class HPService {
    apiUrl = environment.apiUrl;
    hp: HP;

    constructor(private http: HttpClient) { }

    get(): Observable<HP> {
        return this.http.get(`${this.apiUrl}/hp`).pipe(
            map((res) => {
                this.hp = res['data'];
                return this.hp;
            }),
        catchError(this.handleError));
    }

    private handleError(error: HttpErrorResponse) {
        console.log(error);
        // return an observable with a user friendly message
        return throwError('Error! something went wrong.');
    }
}
